/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CommonCostRequest {
    getFixupPrototypeFunction() { return CommonCostRequest.fixupPrototype; }

    static newInstance(model: Partial<CommonCostRequest>): CommonCostRequest {
        let obj = Object.assign(new CommonCostRequest(), model);
        CommonCostRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CommonCostRequest>): CommonCostRequest {
        if (!model) return null;
        return CommonCostRequest.newInstance(<CommonCostRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CommonCostRequest) {
        if (!obj) return;

        models.CommonCostRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CommonCostRequest): boolean {
        Object.setPrototypeOf(obj, CommonCostRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filter) {
            models.AccountFilters.fixupPrototype(this.filter);
        }
        if (this.time_range) {
            models.RangeSelection.fixupPrototype(this.time_range);
        }
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    filter: models.AccountFilters;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    /**
     * specify the start date. start_date: yyyy-mm-dd
     */
    start_date: Date;

    /**
     * specify the end date. end_date: yyyy-mm-dd
     */
    end_date: Date;

    /**
     * Optional timezone of the caller
     */
    time_zone: string;

    time_range: models.RangeSelection;

    /**
     * Query operator
     */
    query: models.QueryOperator;

}
